// Redux store. Slices are added as milestones land.
import { configureStore } from '@reduxjs/toolkit';
import catalogReducer from './catalog-slice.js';
import areaReducer from './area-slice.js';
import selectionsReducer from './selections-slice.js';
import contactReducer from './contact-slice.js';
import inquiryReducer from './inquiry-slice.js';
import settingsReducer from './settings-slice.js';
import snackbarReducer from './snackbar-slice.js';
import participationReducer from './participation-slice.js';
import adminAuthReducer from './admin-auth-slice.js';
import adminCatalogReducer from './admin-catalog-slice.js';
import adminBlacklistReducer from './admin-blacklist-slice.js';
import adminInquiriesReducer from './admin-inquiries-slice.js';
import adminSettingsReducer from './admin-settings-slice.js';
import adminLogosReducer from './admin-logos-slice.js';
import adminParticipationReducer from './admin-participation-slice.js';
import productEditorReducer from './product-editor-slice.js';
import optionEditorReducer from './option-editor-slice.js';
import pricingEditorReducer from './pricing-editor-slice.js';
import { draftAutosave } from './draft-sync.js';

export const store = configureStore({
  reducer: {
    catalog: catalogReducer,
    area: areaReducer,
    selections: selectionsReducer,
    contact: contactReducer,
    inquiry: inquiryReducer,
    settings: settingsReducer,
    snackbar: snackbarReducer,
    participation: participationReducer,
    adminAuth: adminAuthReducer,
    adminCatalog: adminCatalogReducer,
    adminBlacklist: adminBlacklistReducer,
    adminInquiries: adminInquiriesReducer,
    adminSettings: adminSettingsReducer,
    adminLogos: adminLogosReducer,
    productEditor: productEditorReducer,
    optionEditor: optionEditorReducer,
    pricingEditor: pricingEditorReducer,
    adminParticipation: adminParticipationReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(draftAutosave),
});
